import {
    Component,
    Optional,
    Inject,
    Input,
    ViewChild,
    Injector,
  } from '@angular/core';
  
  import {
    NgModel,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    NG_ASYNC_VALIDATORS,
  } from '@angular/forms';
  
  import {ElementBase, animations} from '../form';
  
  @Component({
    selector: 'text-mask-account',
    template: `
    <div class="ui-input-container">
      <span class="md-inputfield md-inputfield">
        <input
          type="text"
          [placeholder]="placeholder"
          [(ngModel)]="value"
          [ngClass]="{'ng-invalid': (invalid | async)}"
          [id]="identifier"
          pInputText
          mask="00000-0" 
          [readonly]="readonly"
          [maxlength]="maxlength"
          [disabled]="disabled"/>
        <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
        <validation
          [@flyInOut]="'in,out'"
          *ngIf="(invalid | async) && !disabled && dirty"
          [messages]="failures | async">
        </validation>
      </span>
    </div>
    `,
    animations,
    providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextBankAccountComponent,
      multi: true,
    }]
  })
  export class TextBankAccountComponent extends ElementBase<string> {
    @Input() public placeholder: string = "";
    
    @Input() public disabled: boolean = false;
    @Input() public readonly: boolean = false;
    @Input() public maxlength: number;
    @Input() public identifier: string;
    @ViewChild(NgModel) model: NgModel;

    constructor(
      @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
      @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
      injector: Injector
    ) {
      super(validators, asyncValidators, injector);
    }
  }
  
  let identifier = 0;



// WEBPACK FOOTER //
// ./src/app/base/base-fields/components/textbankaccount.ts